import type { FC } from 'react';
import { StyledContainer, StyledText, StyledWrapper } from './cookies.styles';
import { NavLink } from 'react-router';
import { PATH } from '../../app.type';
import { Button } from '../Button/button.component';
import { useLocalStorage } from '../../hooks/local-storage.hook';

export const Cookies: FC = () => {
  const [isCookies, setCookies] = useLocalStorage('cookiesAccepted', false);
  const handleClick = () => {
    setCookies(true);
  };

  if (isCookies) return null;

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledText>
          Ta strona używa plików cookie – pozostając na niej, wyrażasz na to
          zgodę. <NavLink to={PATH.COOKIE_POLICY}>Polityka Prywatności</NavLink>
        </StyledText>
        <Button text="X" onClick={handleClick} type="outline" size="small" />
      </StyledContainer>
    </StyledWrapper>
  );
};
